import { NgModule } from '@angular/core';
import { AppSharedModule } from '../app-shared.module';
import { ComponentsModule } from '../components/components.module';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PessoaAuditoriaAcessoListaComponent } from './pessoa-auditoria-acesso-lista/pessoa-auditoria-acesso-lista.component';
import { PessoaAuditoriaAcessoRoutingModule } from './pessoa-auditoria-acesso.routing';
import { PessoaAuditoriaAcessoService } from './pessoa-auditoria-acesso.service';
import {NgxJsonViewerModule} from 'ngx-json-viewer';

@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule,
    FormsModule,
    CalendarModule,
    RadioButtonModule,
    NgxJsonViewerModule
  ],
  declarations: [
    PessoaAuditoriaAcessoListaComponent,
  ],
  exports: [
    PessoaAuditoriaAcessoRoutingModule
  ],
  providers: [
    PessoaAuditoriaAcessoService
  ]
})
export class PessoaAuditoriaAcessoModule { }
